import React, { useCallback } from 'react';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

// Bucket options for "Years of Business"
// Values are stored as-is in BusinessDetail.business_vintage (CharField max_length=50)
export const BUSINESS_VINTAGE_OPTIONS = [
  { value: 'less_than_1', label: 'Less than 1 year' },
  { value: '1_to_3',      label: '1 – 3 years' },
  { value: '3_to_5',      label: '3 – 5 years' },
  { value: '5_to_10',     label: '5 – 10 years' },
  { value: 'more_than_10', label: 'More than 10 years' },
] as const;

interface BusinessVintageInputProps {
  // Controlled pattern (used by JourneyPage)
  value?: { business_vintage?: string | number | null };
  onChange?: (val: { business_vintage: string }) => void;
  disabled?: boolean;
  // Legacy pattern
  initialData?: { business_vintage?: string };
  onDataChange?: (data: { business_vintage: string }) => void;
}

const BusinessVintageInput: React.FC<BusinessVintageInputProps> = ({
  value,
  onChange,
  disabled,
  initialData,
  onDataChange,
}) => {
  const rawVintage = value?.business_vintage ?? initialData?.business_vintage ?? '';
  const vintage = String(rawVintage === null || rawVintage === undefined ? '' : rawVintage);

  const handleChange = useCallback((val: string) => {
    onChange?.({ business_vintage: val });
    onDataChange?.({ business_vintage: val });
  }, [onChange, onDataChange]);

  return (
    <div className="space-y-2">
      <Label htmlFor="business_vintage" className="text-gray-500 font-medium">
        Years of Business <span className="text-red-500">*</span>
      </Label>
      <Select
        value={vintage || undefined}
        onValueChange={handleChange}
        disabled={disabled}
      >
        <SelectTrigger
          id="business_vintage"
          className="border-gray-200 focus:border-intellend-green focus:ring-intellend-green rounded-xl py-6"
        >
          <SelectValue placeholder="Select years of business" />
        </SelectTrigger>
        <SelectContent>
          {BUSINESS_VINTAGE_OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default BusinessVintageInput;
